import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { stepValidationFactory } from 'actions/submissionFormActions';
import scrollToFirstError from 'lib/utils/scrollToFirstError';
import OrganiserFieldset from './fieldsets/OrganiserFieldset';

class ContactForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
  }

  render() {
    const { formErrors, isLoading, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <OrganiserFieldset formErrors={formErrors} isLoading={isLoading} />
        <button type="submit" className="d-none" />
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  destroyOnUnmount: false,
  asyncValidate: stepValidationFactory('contact'),
  onSubmitFail: scrollToFirstError,
  persistentSubmitErrors: true,
})(ContactForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/ContactForm.jsx